import { Injectable } from "@angular/core";
import { FranchiseType, PaymentType } from "../../enums/enums";
import { PaymentForm, ReissueRequest } from "../../models/reissue.model";
import { ExchangeQuoteRequest } from "../../models/voluntary-change.model";

@Injectable({
  providedIn: 'root'
})
export class MapPaymentApi {
  map(quote: ExchangeQuoteRequest, remarks: string[], formOfPayment?: PaymentForm): ReissueRequest {
    return {
      ...quote,
      formOfPayment: {
        isCash: formOfPayment.paymentType === PaymentType.Cash,
        creditCard: formOfPayment.paymentType !== PaymentType.Cash
          ? {
            number: formOfPayment.formData?.number,
            verificationCode: formOfPayment.formData?.verificationCode,
            franchise: this.getFranchise(formOfPayment.formData?.number),
            approvalCode: formOfPayment.formData?.approvalCode,
            expirationYear: formOfPayment.formData?.expirationDate?.year,
            expirationMonth: formOfPayment.formData?.expirationDate?.month,
          }
          : null,
      },
      remarks: this.getRemarks(formOfPayment?.formData?.remark, remarks),
      passengers: quote?.passengers?.map((passenger) => ({ ticketNumber: passenger?.ticketNumber, passengerType: passenger?.passengerType }))
    };
  }

  public getFranchise(cardNumber: string): FranchiseType | string{
    const franchises = [
      {
        regex: '^3[47]\\d{0,13}',
        cardtype: FranchiseType.Amex,
      },
      {
        regex: '^(?:6011|65\\d{0,2}|64[4-9]\\d?)\\d{0,12}',
        cardtype: FranchiseType.Discover,
      },
      {
        regex: '^3(?:0([0-6]|9)|[689]\\d?)\\d{0,11}',
        cardtype: FranchiseType.Diners,
      },
      {
        regex: '^(5[1-6]\\d{0,2}|22[2-9]\\d{0,1}|2[3-7]\\d{0,2}|36\\d{0,2}|58\\d{0,2})\\d{0,12}',
        cardtype: FranchiseType.MasterCard,
      },
      {
        regex: '^4\\d{0,15}',
        cardtype: FranchiseType.Visa,
      },
      {
        regex: '^1',
        cardtype: FranchiseType.UATP,
      },
      {
        regex: '^35',
        cardtype: FranchiseType.JCB,
      },
      {
        regex: '^5602',
        cardtype: FranchiseType.NewZealandBank,
      },
    ];

    return franchises.find((franchise) => cardNumber?.match(franchise.regex))?.cardtype;
  }

  private getRemarks(remark: string, remarks: string[]): string[] {
    if (remark) {
      return [...remarks ?? [], remark];
    }

    return remarks ?? [];
  }
}